<template>
    <div class="form-group">
<!--        <label v-if="label" :for="name">{{label}}</label>-->
        <label v-if="label" :for="name">{{label}}</label><span class="text-danger" v-if="required"> *</span>

        <div class="form-control-plaintext pt-3">
            <switches :id="name" :name="name" v-model="model[name]" theme="bootstrap" color="danger"
                type-bold="true" @input="onChange" :disabled="!!disabled" />
        </div>
        <small class="form-text text-danger" v-if="errors[name]" v-text="errors[name][0]" />
    </div>
</template>

<script>
    import Switches from 'vue-switches';

    export default {
        props: {
            label: {
                type: String
            },

            name: {
                type: String,
                required: true
            },

            model: {
                type: [Object, Array],
                required: true
            },

            errors: {
                type: [Object, Array],
                default: () => ({})
            },
            required:{
                type: Boolean,
            },
            disabled: {
                type: [Boolean, Number],
                default: false
            }
        },

        components: {
            Switches
        },

        methods:{
            onChange(status){    
                let payload = {
                    status: status,
                    perm: this.model
                };            
                this.$emit('change', payload);
            }
        }
    };

</script>

<style>
</style>
